import { socialLinks } from "./socialLinks";

interface SocialIconsProps {
  className?: string;
  iconSize?: string;
}

const SocialIcons = ({ className = "gap-3.5", iconSize = "w-[21px] h-[21px]" }: SocialIconsProps) => (
  <div className={`flex items-center ${className}`}>
    {socialLinks.map((s) => (
      <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer" aria-label={s.label} className="group transition-transform duration-200 hover:scale-[1.12]">
        <svg viewBox="0 0 24 24" className={`${iconSize} fill-foreground/40 transition-colors duration-200`} style={{ ['--hover-color' as string]: s.color }}>
          <path d={s.path} className="group-hover:fill-[var(--hover-color)]" />
        </svg>
      </a>
    ))}
  </div>
);

export default SocialIcons;
